import { useI18n } from "../i18n";

interface MobileHeaderProps {
  onOpenSidebar: () => void;
}

export default function MobileHeader({ onOpenSidebar }: MobileHeaderProps) {
  const { t } = useI18n();
  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-sm border-b border-linen-200 px-4 py-3 md:hidden">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-serif text-charcoal tracking-wide">
          Chystotil
        </h1>
        <a
          href="/admin"
          className="ml-auto mr-3 flex min-h-[44px] items-center rounded-soft px-2 text-sm text-sage-600 transition-colors hover:text-sage-700 hover:underline whitespace-nowrap"
        >
          {t.sidebar.tryOnLinks} →
        </a>
        <button
          onClick={onOpenSidebar}
          className="w-11 h-11 bg-sage-500 rounded-full flex items-center justify-center text-white shadow-soft active:scale-95 transition-transform"
          aria-label={t.header.openCreatePanel}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
      </div>
    </header>
  );
}
